import { Fragment, memo } from "react";
import { Box, Typography, Divider, useTheme } from "@mui/material";
import PropTypes from "prop-types";

const FGLabelValueList = ({
  items = [],
  layout = "column",
  showDivider = false,
  labelWidth = 150,
}) => {
  const theme = useTheme();
  return (
    <Box>
      {items.map(({ label, value }, index) => (
        <Fragment key={label}>
          <Box
            display="flex"
            flexDirection={layout === "row" ? "row" : "column"}
            justifyContent="flex-start"
            alignItems={layout === "row" ? "center" : "flex-start"}
            py={2}
            width="100%"
          >
            <Typography
              variant="body2"
              color={theme.palette.grey["A300"]}
              sx={layout === "row" ? { minWidth: labelWidth } : {}}
            >
              {label}
            </Typography>
            <Typography
              variant="body2"
              fontWeight="bold"
              sx={{
                wordBreak: "break-word",
                overflowWrap: "anywhere",
                whiteSpace: "normal",
                flex: 1,
              }}
            >
              {value}
            </Typography>
          </Box>
          {showDivider && index !== items.length - 1 && <Divider />}
        </Fragment>
      ))}
    </Box>
  );
};

export default memo(FGLabelValueList);

FGLabelValueList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ),
  layout: PropTypes.oneOf(["column", "row"]),
  showDivider: PropTypes.bool,
  labelWidth: PropTypes.number,
};
